import { Badge } from '@/components/ui/badge';
import type { ContractStatus } from '@/lib/contractStatus';

const statusVariantMap: Record<
  ContractStatus,
  'active' | 'expired' | 'cancelled'
> = {
  Active: 'active',
  Expired: 'expired',
  Cancelled: 'cancelled',
};

export function ContractStatusBadge({ status }: { status: ContractStatus }) {
  return <Badge variant={statusVariantMap[status]}>{status}</Badge>;
}
